import styled from 'styled-components';
import tw from 'twin.macro';

export const StyledSearchButton = styled.button`
    ${tw`w-6 h-6`}
`